export enum PromoStatusTransitionType {
  ACTIVATE = "ACTIVATE",
  RE_ACTIVATE = "RE_ACTIVATE",
  MARK_COMPLETED = "MARK_COMPLETED",
  CANCEL = "CANCEL",
  DELETE = "DELETE",
}
